import(/* webpackMode: "eager" */ "/home/runner/work/kst-frontend/kst-frontend/node_modules/next/dist/client/link.js")